import { setGlobalRequestHeader } from "@virgodev/bazaar/functions/api";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userData: JSON.parse(localStorage.getItem("userData")),
  },
  mutations: {
    userData(state, value) {
      state.userData = value;
      localStorage.setItem("userData", JSON.stringify(value));

      if (value) {
        setGlobalRequestHeader("Authorization", `Token ${value.drf_token}`);
      } else {
        setGlobalRequestHeader("Authorization", undefined);
      }
    },
  },
});
